/* eslint-disable no-param-reassign */
import { SystemFuncArgs } from '$legacyecstatic';
import { Components } from 'editor/components';
import KeyboardEvents from 'editor/components/KeyboardEvents';
import Tool, { EditorTools } from 'editor/components/Tool';
import keyboardEventHandlers from './keyboardEventHandlers';

export const addKeyboardEventsComponents = [KeyboardEvents, Tool];

export function addKeyboardEvents(args: SystemFuncArgs<Components>): void {
  const { components, world, entity } = args;
  const keyboardEvents = components.get(KeyboardEvents);

  if (entity.state === 'creating') {
    const keydownHandler = (evt: KeyboardEvent) => {
      const toolComp = entity.get<Tool<EditorTools>>(Tool);

      keyboardEventHandlers[toolComp.tool].keydown({ evt, world });
    };

    const keyupHandler = (evt: KeyboardEvent) => {
      const toolComp = entity.get<Tool<EditorTools>>(Tool);

      keyboardEventHandlers[toolComp.tool].keyup({ evt, world });
    };

    keyboardEvents.eventHandlers = {
      keydown: keydownHandler,
      keyup: keyupHandler,
    };

    document.addEventListener('keydown', keyboardEvents.eventHandlers.keydown);
    document.addEventListener('keyup', keyboardEvents.eventHandlers.keyup);
  } else if (entity.state === 'destroying') {
    document.removeEventListener(
      'keydown',
      keyboardEvents.eventHandlers.keydown
    );
    document.removeEventListener('keyup', keyboardEvents.eventHandlers.keyup);
  }
}
